"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanDescription = void 0;
const InvalidResult_1 = __importDefault(require("./InvalidResult"));
exports.booleanDescription = {
    userFacingTitle: 'boolean',
    userFacingValue: boolean => (boolean ? 'true' : 'false'),
    validate(value) {
        if (typeof value !== 'boolean') {
            return new InvalidResult_1.default(`Not a boolean: ${value}`);
        }
        return value;
    },
};
